<svelte:options customElement="mg-tag" />

<script lang="ts">
    import type { packed } from "magnetar-common";
    import type * as Misskey from "calckey-js";
    import { host as hostRaw } from "@/config";

    import { toUnicode } from "punycode";

    let {
        user,
        detail,
    }: {
        user: packed.PackUserBase | Misskey.entities.User;
        detail?: boolean;
    } = $props();

    const host = toUnicode(hostRaw);
</script>

<span class="mg-tag">
    <span class="name">@{user.username}</span>{#if user.host || detail}<span
            class="host"
        >
            @{user.host || host}
        </span>
    {/if}
</span>

<style lang="scss">
    .mg-tag {
        > .host {
            opacity: 0.5;
        }
    }
</style>
